import React from 'react'
import { Chip, Stack, Typography } from '@mui/material'

interface FRIntervalButtonsProp {
  frInterval: string
  updateFRInterval: (val: string) => void
}

const FRIntervalButtons: React.FC<FRIntervalButtonsProp> = ({ frInterval, updateFRInterval }) => {
  return (
    <Stack direction='row' columnGap={1} sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography fontSize='small'>
        Interval:
      </Typography>
      <Chip
        label='3D'
        onClick={() => {
          updateFRInterval('3D')
        }}
        variant='outlined'
        size='small'
        color={ frInterval === '3D' ? 'primary' : 'default' }
      />
      <Chip
        label='7D'
        onClick={() => {
          updateFRInterval('7D')
        }}
        variant='outlined'
        size='small'
        color={ frInterval === '7D' ? 'primary' : 'default' }
      />
      <Chip
        label='30D'
        onClick={() => {
          updateFRInterval('30D')
        }}
        variant='outlined'
        size='small'
        color={ frInterval === '30D' ? 'primary' : 'default' }
      />
    </Stack>
  )
}

export default FRIntervalButtons
